"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationLifecycle = {
  NEW: "new",
  ACTIVE: "active",
  OLD: "old",
  EXPIRED: "expired"
};